import COMPANIES from "./ListCompany";
import session from "./session";

var CONFIG_COMPANY = Object.assign({}, COMPANIES.GLOBAL_PANEL, {
    setCompany: function(name) {
        session.saveCompany(name);
        var companyObject = null;
        for (let key in COMPANIES) {
            if (COMPANIES.hasOwnProperty(key)) {
                let company = COMPANIES[key];
                if(company.NAME === name){
                    companyObject = company;
                }
            }
        }
        if(companyObject != null){
            Object.assign(CONFIG_COMPANY, companyObject);
            return;
        }
        COMPANIES.DYNAMIC_COMPANY.NAME = name;
        Object.assign(CONFIG_COMPANY, COMPANIES.DYNAMIC_COMPANY); // Mutacija objekta
    },
});

export default CONFIG_COMPANY


// WEBPACK FOOTER //
// ./src/services/myConfig.js